// Copyright (c) 2015 Steven Sojka
import { ApplicateOptions, Applicator } from './Applicator';

export class PreValueApplicator extends Applicator {
  apply({ value, config: { execute }, args }: ApplicateOptions): any {
    return execute(value, ...args);
  }
}
